import { z } from 'zod';

export const TemplateFormValuesSchema = z.object({
  isActive: z.boolean(),
  description: z.string(),
  businessProcess: z.string().min(1),
  templateName: z.string().min(3),
  applyRules: z
    .object({
      paymentType: z.string().optional(),
      applyingFor: z.string().optional(),
    })
    .superRefine((data, ctx) => {
      if (!data.paymentType && !data.applyingFor) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'At least one apply rule must be filled',
          path: ['paymentType'],
        });
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'At least one apply rule must be filled',
          path: ['applyingFor'],
        });
      }
    }),
});

export const StagesAttributeBaseSchema = z.object({
  value: z.boolean(),
  isRequired: z.boolean(),
  name: z.string().min(1),
});

export const StagesChecklistAttributeSchema = StagesAttributeBaseSchema.extend({
  field: z.literal('checklist'),
});

export const StagesDocumentAttributeSchema = StagesAttributeBaseSchema.extend({
  field: z.literal('document'),
  isPII: z.boolean(),
  id: z.string().uuid(),
  notify: z.array(z.string().uuid()),
  availableForRoles: z.array(z.string()),
});

export const StagesConstructorEntitySchema = z.object({
  id: z.string().uuid().nullable(),
  name: z.string().min(3),
  winProbability: z.number().nullable(),
  listOfAttributes: z.array(
    z.discriminatedUnion('field', [StagesChecklistAttributeSchema, StagesDocumentAttributeSchema])
  ),
  recipients: z.array(
    z.object({
      name: z.string(),
      userProfileId: z.string().uuid().optional(),
      role: z.enum(['SALES_MANAGER', 'SALES_REP', 'FINANCE_MANAGER']).optional(),
    })
  ),
});

export const StagesConstructorListingSchema = z.object({
  bodyFields: z.array(StagesConstructorEntitySchema),
});
